import { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import { fetchUserShip } from '../services';
import { IshipAddres } from '../components/interfaces';

export const useShippingData = (
    location: any, 
    setUserInfo: React.Dispatch<React.SetStateAction<IshipAddres>>,
    isCreatingNewAddress: boolean
) => {
    const dispatch = useAppDispatch();
    const userId = useAppSelector((state) => state.user.user?.id);
    const selectedAddress = useAppSelector((state) => state.user.selectedAddress);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      let active = true;

      if (isCreatingNewAddress) {
        setLoading(false);
        return () => {
          active = false;
        };
      }

      const loadShippingInfo = async () => {
            if (!userId) return;

            setLoading(true);
            try {
                const address = await dispatch(fetchUserShip({
                    currentPage: location.pathname,
                    selectedAddress,
                })).unwrap();

                if (active) {
                    setUserInfo((prevState: any) => ({
                        ...prevState,
                        ...(address || {}),
                    }));
                }
            } catch (error) {
                console.error('Error loading shipping data:', error);
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        loadShippingInfo();

        return () => {
            active = false;
        };
    }, [dispatch, isCreatingNewAddress, userId, selectedAddress, location.pathname, setUserInfo]);

    return { loading };
};
